var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRightArrow = function SvgIconRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 9,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#422800",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 1 3.342 3.342L1 7.683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.72 1 3.34 3.342-3.34 3.341"
  }))));
};
export default SvgIconRightArrow;